import React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import Masion from "./../../../images/resources/masion.png";

const View = (props) => {
  const matches = useMediaQuery("(min-width:1000px)");
  const itemData = [
    {
      img: "https://placehold.co/650x600/jpg",
      title: "Breakfast",
      rows: 2,
      cols: 2,
    },
    {
      img: "https://placehold.co/650x300/jpg",
      title: "Coffee",
      author: "@arwinneil",

      cols: 2,
    },
    {
      img: "https://placehold.co/650x300/jpg",
      title: "Coffee",
      author: "@arwinneil",

      cols: 2,
    },
  ];

  function srcset(image, size, rows = 1, cols = 1) {
    return {
      src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
      srcSet: `${image}?w=${size * cols}&h=${size * rows
        }&fit=crop&auto=format&dpr=2 2x`,
    };
  }







  //   try {
  //     setLoading(true)
  //     async function getAuctionOne() {
  //       setAuction(results);
  //       setLoading(false)
  //     }
  //     getAuctionOne().catch(console.error);
  //   } catch (error) {
  //     setLoading(false)
  //   }
  // };

  // useEffect(() => {
  //   FetchData()
  // }, []);

  const handleUpcomming = (searchValue) => {
  };



  return (
    <div className="boxed_wrapper">
      <section
        className="breadcrumb-area"
        style={{
          backgroundImage: `url(${Masion})`
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="inner-content clearfix">
                <div className="title">
                  <h1>{props.param}</h1>
                </div>
                <div className="breadcrumb-menu">
                  <ul className="clearfix">
                    <li style={{ marginLeft: 50 }}>Home</li>
                    <li className="" style={{ color: "#000000" }}>
                      Maison
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="events-single-area">
        <div className="container">
          
          <div className="row">
            <div className="col-xl-8">
              <div className="events-single-text-box">
                <h2>Leon Gallery Maison</h2>
                <p>
                Nestled within the elegant confines of León Gallery International at Corinthian Plaza, León Gallery Maison epitomizes an exquisite haven tailored for discerning individuals who appreciate life's luxuries. Immerse yourself in a meticulously curated experience where opulence meets artistry. This distinguished space showcases an exclusive ensemble of objets d'art, home accessories, and jewelry, each piece handpicked to reflect the epitome of sophistication.
                </p>
                <p>
                  The ambiance at León Gallery Maison is a seamless blend of refinement and cultural resonance, inviting patrons to explore the intersection of 
                  aesthetics and craftsmanship. From captivating artworks to timeless home accents and exquisite jewelry, every item in this collection tells a 
                  story of unparalleled craftsmanship and refined taste.
                </p>
                <p>
                Indulge your senses in the allure of León Gallery Maison, where each visit promises a journey through the realms of beauty and elegance. Whether you seek a statement piece for your living space, a tasteful home accessory, or a piece of jewelry that exudes both rarity and allure, León Gallery Maison stands as a distinguished destination for those who seek the pinnacle of the finer things in life.
                </p>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="events-single-info-box">
                <ul className="events-info">
                  <li>
                    <p>Type :</p>
                    <span>Gallery Talk</span>
                  </li>
                  <li>
                    <p>Hours :</p>
                    <span>Monday–Saturday 9:00 AM - 6:00 PM</span>
                  </li>
                  <li>
                    <p>Venue :</p>
                    <span>
                      Eurovilla 1, Rufino corner Legazpi Street, Legazpi
                      Village, Makati, 1224
                    </span>
                  </li>
                </ul>
                <div className="social-links">
                  <p>Shear :</p>
                  <ul className="sociallinks-style-two">
                    <li>
                      <a href="#">
                        <i className="fa fa-facebook" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-twitter" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-youtube-play" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      

      <section className="gallery-area">
        <div className="layer-outer"></div>
        <div className="container">
          <div className="visit-day-select">
            <h1>Auction</h1>

            <div className="sec-title text-center" style={{ paddingTop: 20 }}>
              <ul className="tab-btns tab-buttons text-center clearfix">
                <li
                  data-tab="#today"
                  className="tab-btn"
                  onClick={() => handleUpcomming("UPCOMING")}
                >
                  <span>Upcoming</span>
                </li>
                <li
                  data-tab="#tomorrow"
                  className="tab-btn"
                  onClick={() => handleUpcomming("PREVIOUS")}
                >
                  <span>Past</span>
                </li>
                
              </ul>
            </div>
          </div>

          <div className="row items-container clearfix">
            
            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 masonry-item all objects pic">
              <div className="single-art-box-style2 marbtm50">
                <div className="img-holder">
                  <img src={'https://placehold.co/570x570/jpg'} alt="Awesome Image" />
                  <div className="overlay-content">
                    <div className="zoom-button">
                      <a
                        className="lightbox-image"
                        data-fancybox="gallery"
                        href={'https://placehold.co/570x570/jpg'}
                      >
                        <i
                          className="fa fa-search-plus"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="text-holder">
                  <h3>
                    <a href="#">{'Sample Link'}</a>
                  </h3>
                  <span>
                    
                  </span>
                  <span>
                    
                  </span>
                </div>
              </div>
            </div>
            

            <ImageList
              sx={{ width: ' 100%', paddingBottom: 10 }}
              variant="quilted"
              cols={4}
              rowHeight={matches === true ? 300 : 120}
            >
              {itemData.map((item) => (
                <ImageListItem

                  key={item.img}
                  cols={item.cols || 1}
                  rows={item.rows || 1}
                >
                  <img

                    {...srcset(item.img, 121, item.rows, item.cols)}
                    alt={item.title}
                    loading="lazy"
                  />
                </ImageListItem>
              ))}
            </ImageList>
          </div>
        </div>
      </section>
    </div>
  );
};

export default View;
